import { get } from './lodash';
import { Trans } from 'react-i18next';

export const grantTrialProgramProjectIds =
  import.meta.env.REACT_APP_ENV_VALUE === 'production'
    ? [3203, 3213, 1473, 2727, 2875] // [1473, 2727, 2875] - BL Test Activity
    : import.meta.env.REACT_APP_ENV_VALUE === 'stage'
      ? [3098, 3099, 3100, 1473, 2727, 2875] // [1473, 2727, 2875] - BL Test Activity
      : [1473, 2727, 2875];

/*
 * From id 5000 onward all tooltips are only available for this specific projects (not in db level too)
 * not those ids tooltips are available for existing system
 */
export const grantTrialToolTips = (t) => [
  /*
   * page - activity Navigation bar (activity steps)
   * field - Goal
   */
  {
    tooltipId: 10,
    content: t('grant_trial.tooltips.goal'),
  },
  /*
   * page - activity Navigation bar (activity steps)
   * field - Objective
   */
  {
    tooltipId: 11,
    content: t('grant_trial.tooltips.objective'),
  },
  /*
   * page - activity Navigation bar (activity steps)
   * field - Evidence
   */
  {
    tooltipId: 12,
    content: t('grant_trial.tooltips.evidence'),
  },
  /*
   * page - activity Navigation bar (activity steps)
   * field - TOC
   */
  {
    tooltipId: 13,
    content: t('grant_trial.tooltips.toc'),
  },
  /*
   * page - activity Navigation bar (activity steps)
   * field - Activity plan
   */
  {
    tooltipId: 14,
    content: t('grant_trial.tooltips.activity_plan'),
  },
  /*
   * page - activity Navigation bar (activity steps)
   * field - Evaluation
   */
  {
    tooltipId: 15,
    content: t('grant_trial.tooltips.evaluation'),
  },
  /*
   * page - activity Navigation bar (activity steps)
   * field - Documentation
   */
  {
    tooltipId: 18,
    content: t('grant_trial.tooltips.documentation'),
  },
  /*
   * page - activity Navigation bar (activity steps)
   * field - Report
   */
  {
    tooltipId: 19,
    content: t('grant_trial.tooltips.report'),
  },
  /*
   * page - activity goal
   * field -  primary policy
   */
  {
    tooltipId: 31,
    content: null, // removed tooltip
  },
  /*
   * page - activity -> goal
   * field - secondary policy
   */
  {
    tooltipId: 176,
    content: null, // removed tooltip
  },
  /*
   * page - activity -> objective
   * field - Select objective for {{domain name}}
   */
  {
    tooltipId: 21,
    content: null,
  },
  /*
   * page - activity -> objective
   * field - Select objective for {{domain name}}
   */
  {
    tooltipId: 22,
    content: null,
  },
  /*
   * page - activity -> objective
   * field - select objective for {{domain name}}
   */
  {
    tooltipId: 104,
    content: null,
  },
  // TODO: need to check below
  /*
   * page - activity -> evidence
   * field - Search evidence
   */ {
    tooltipId: 23,
    content: t('grant_trial.tooltips.search_evidence'),
  },
  /*
   * page - activity -> evidence
   * field - Add new evidence
   */ {
    tooltipId: 24,
    content: t('grant_trial.tooltips.add_new_evidence'),
  },
  /*
   * page - activity -> evidence
   * field - Content
   */ {
    tooltipId: 29,
    content: t('grant_trial.tooltips.evidence_content'),
  },
  /*
   * page - activity -> evidence
   * field - Source
   */ {
    tooltipId: 30,
    content: t('grant_trial.tooltips.evidence_source'),
  },
  /*
   * page - activity -> ToC
   * field - Aiming for
   */ {
    tooltipId: 33,
    content: t('grant_trial.tooltips.summarise_evidence'),
  },

  /*
   * page - activity -> ToC
   * field - Aiming for
   */ {
    tooltipId: 34,
    content: t('grant_trial.tooltips.summarise_evidence'),
  },
  /*
   * page - activity -> ToC
   * field - We will
   */ {
    tooltipId: 35,
    content: t('grant_trial.tooltips.we_will'),
  },
  /*
   * page - activity -> ToC
   * field - We will
   */ {
    tooltipId: 36,
    content: t('grant_trial.tooltips.we_will'),
  },
  /*
   * page - activity -> Activity plan
   * field - Activity name
   */ {
    tooltipId: 37,
    content: t('grant_trial.tooltips.activity_name'),
  },
  /*
   * page - activity -> Activity plan
   * field - Select activity type
   */ {
    tooltipId: 77,
    content: t('grant_trial.tooltips.select_activity_type'),
  },
  /*
   * page - activity -> Activity plan
   * field - Summarise activity
   */ {
    tooltipId: 100,
    content: t('grant_trial.tooltips.activity_summary'),
  },

  // FIXME:  couldn't find tooltip [added missing tool tip for existing system]

  /*
   * page - activity -> Activity plan
   * field - Activity Members (add - 99) [search - 96 (no need this)]
   */ {
    tooltipId: 99,
    content: t('grant_trial.tooltips.activity_members'),
  },

  // FIXME:  couldn't find tooltip
  /*
   * page - activity -> Activity plan
   * field - Projected Program contribution
   */ {
    tooltipId: 5000,
    content: t('grant_trial.tooltips.projected_program_contribution'),
  },

  // FIXME: need to check tooltip for projected and actual
  /*
   * page - activity -> Activity plan
   * field - Expenditure [projected - 38, actual - 62]
   */ {
    tooltipId: 38,
    content: t('grant_trial.tooltips.total_amount_needed'),
  },
  /*
   * page - activity -> Activity plan
   * field - Expenditure [projected - 38, actual - 62]
   */ {
    tooltipId: 62,
    content: t('grant_trial.tooltips.total_amount_needed'),
  },

  /*
   * page - activity -> Activity plan
   * field - Green light date
   */ {
    tooltipId: 108,
    content: t('grant_trial.tooltips.green_light_date'),
  },

  /*
   * page - activity -> Activity plan
   * field - Venue [Projected]
   */ {
    tooltipId: 126,
    content: t('grant_trial.tooltips.select_new_venue'),
  },
  /*
   * page - activity -> Activity plan
   * field - Venue [Actual]
   */ {
    tooltipId: 134,
    content: t('grant_trial.tooltips.select_new_venue'),
  },

  /*
   * page - activity -> Activity plan
   * field - Contractor [projected]
   */ {
    tooltipId: 127,
    content: t('grant_trial.tooltips.select_new_contractor'),
  },
  /*
   * page - activity -> Activity plan
   * field - Contractor [actual]
   */ {
    tooltipId: 135,
    content: t('grant_trial.tooltips.select_new_contractor'),
  },

  /*
   * page - activity -> Activity plan
   * field - Partner
   */ {
    tooltipId: 5001,
    content: t('grant_trial.tooltips.select_new_partner'),
  },

  /*
   * page - activity -> Activity plan
   * field - Active participants free [projected]
   */ {
    tooltipId: 185,
    content: t('grant_trial.tooltips.active_participants_free'),
  },
  /*
   * page - activity -> Activity plan
   * field - Active participants free [actual]
   */ {
    tooltipId: 154,
    content: t('grant_trial.tooltips.active_participants_free'),
  },

  /*
   * page - activity -> Activity plan
   * field - Receptive participants free [projected]
   */ {
    tooltipId: 45,
    content: t('grant_trial.tooltips.receptive_participants_free'),
  },
  /*
   * page - activity -> Activity plan
   * field - Receptive participants free [actual]
   */ {
    tooltipId: 69,
    content: t('grant_trial.tooltips.receptive_participants_free'),
  },

  /*
   * page - activity -> Activity plan
   * field - Active participants paid
   */ {
    tooltipId: 137,
    content: t('grant_trial.tooltips.active_participants_paid'),
  },
  /*
   * page - activity -> Activity plan
   * field - Active participants paid
   */ {
    tooltipId: 155,
    content: t('grant_trial.tooltips.active_participants_paid'),
  },

  /*
   * page - activity -> Activity plan
   * field - Receptive participants paying [projected]
   */ {
    tooltipId: 179,
    content: t('grant_trial.tooltips.receptive_participants_paying'),
  },
  /*
   * page - activity -> Activity plan
   * field - Receptive participants paying [actual]
   */ {
    tooltipId: 162,
    content: t('grant_trial.tooltips.receptive_participants_paying'),
  },

  /*
   * page - activity -> Activity plan
   * field - Active participants paying [projected]
   */ {
    tooltipId: 138,
    content: t('grant_trial.tooltips.active_participants_paying'),
  },
  /*
   * page - activity -> Activity plan
   * field - Active participants paying [actual]
   */ {
    tooltipId: 186,
    content: t('grant_trial.tooltips.active_participants_paying'),
  },

  /*
   * page - activity -> Activity plan
   * field - Do you want to identify any core groups within these participants?
   */ {
    tooltipId: 208,
    content: t('grant_trial.tooltips.create_sub_group'),
  },
  /*
   * page - activity -> Evaluation
   * field - Objective
   */ {
    tooltipId: 210,
    content: t('grant_trial.tooltips.select_objectives'),
  },
  /*
   * page - activity -> Evaluation
   * field - Select evaluation group
   */ {
    tooltipId: 211,
    content: t('grant_trial.tooltips.select_evaluation_group'),
  },
  /*
   * page - activity -> Evaluation
   * field - Select Evaluation method
   */ {
    tooltipId: 129,
    content: t('grant_trial.tooltips.select_evaluation_method'),
  },
  /*
   * page - activity -> Evaluation
   * field - Select Data Collection method
   */ {
    tooltipId: 131,
    content: t('grant_trial.tooltips.select_data_collection_method'),
  },
  /*
   * page - activity -> Evaluation
   * field - Question
   */ {
    tooltipId: 213,
    content: t('grant_trial.tooltips.select_outcome'),
  },
  /*
   * page - activity -> Evaluation
   * field -  Create multi-stage evaluation series
   */ {
    tooltipId: 5002,
    content: t('grant_trial.tooltips.create_multi_stage_evaluation_series'),
  },
  /*
   * page - activity -> Evaluation
   * field - Activity approval
   */ {
    tooltipId: 5003,
    content: t('grant_trial.tooltips.activity_approval'),
  },
  /*
   * page - activity -> Documentation
   * field - Activity Description
   */ {
    tooltipId: 80,
    content: t('grant_trial.tooltips.activity_description'),
  },
  /*
   * page - activity -> Documentation
   * field - Upload media
   */ {
    tooltipId: 57,
    content: t('grant_trial.tooltips.upload_media'),
  },
  /*
   * page - activity -> Documentation
   * field - Actual Inputs
   */ {
    tooltipId: 5004,
    content: t('grant_trial.tooltips.actual_inputs'),
  },
  /*
   * page - activity -> Documentation
   * field - Actual Outputs
   */ {
    tooltipId: 5005,
    content: t('grant_trial.tooltips.actual_outputs'),
  },
  /*
   * page - activity -> Documentation
   * field - Evaluation analysis
   */ {
    tooltipId: 219,
    content: t('grant_trial.tooltips.evaluation_results_analysis'),
  },
  /*
   * page - activity -> Documentation
   * field - Reflection
   */ {
    tooltipId: 81,
    content: t('grant_trial.tooltips.reflection'),
  },
  /*
   * page - activity -> Documentation
   * field - Unpublished report
   */ {
    tooltipId: 82,
    content: t('grant_trial.tooltips.unpublished_report'),
  },
  /*
   * page - activity -> Documentation
   * field - make visible in Takso library
   */ {
    tooltipId: 111,
    content: t('grant_trial.tooltips.make_visible_in_takso_library'),
  },
];

// for changing hard coded or defines label texts or texts in system
export const grantTrialDefinedTexts = (t, textValue) => [
  /*
   * Original Text: Organisation Goal to be addressed, Select Goal
   */
  {
    id: 1,
    text: t('grant_trial.defined_texts.goal'),
  },
  /*
   * Original Text: Your primary policy domain will be populated based on the selected goal
   */
  {
    id: 2,
    text: t('grant_trial.defined_texts.primary_policy_domain_populated'),
  },
  /*
   * Original Text: Your secondary policy domain will be populated based on the selected goal
   */
  {
    id: 3,
    text: t('grant_trial.defined_texts.secondary_policy_domain_populated'),
  },
  /*
   * Original Text: Select objective for {{domain name}} domain
   */ {
    id: 4,
    text: t('grant_trial.defined_texts.objective_for_domain', {
      domainName: textValue,
    }),
  },
  /*
   * Original Text: Summarise the strongest points of evidence that leads to the activity
   */ {
    id: 5,
    text: t(
      'grant_trial.defined_texts.continue_sentence_with_evidence_summary'
    ),
  },
  /*
   * Original Text: Describe the activity required to achieve the objective (TODO: check in text it's ->outcome)
   */ {
    id: 6,
    text: t('grant_trial.defined_texts.continue_sentence_with_description'),
  },
  /*
   * Original Text: Do you want to identify any core groups within these participants?
   */ {
    id: 7,
    text: t('grant_trial.defined_texts.create_participant_sub_group'),
  },
  /*
   * Original Text: Provide notes about the activity
   */ {
    id: 8,
    text: ' ', // to empty or remove label text send string with space
  },
  /*
   * Original Text: Make visible in Takso library
   */ {
    id: 9,
    text: t('grant_trial.defined_texts.add_report_to_takso_library'),
  },
];

/*
 * Grant Trial Help Panel Texts
 */
export const grantTrialHelpTips = [
  /**
   * page - Goal
   */
  {
    helpTipType: 'activity.goal',
    content: <Trans i18nKey="grant_trial.help_tips.activity_goal" />,
  },

  /**
   * page - Objective
   */
  {
    helpTipType: 'activity.objective',
    content: <Trans i18nKey="grant_trial.help_tips.activity_objective" />,
  },

  /**
   * page - Evidence
   */
  {
    helpTipType: 'activity.evidence',
    content: <Trans i18nKey="grant_trial.help_tips.activity_evidence" />,
  },

  /**
   * page - TOC
   */
  {
    helpTipType: 'activity.theoryOfChange',
    content: (
      <Trans i18nKey="grant_trial.help_tips.activity_theory_of_change" />
    ),
  },

  /**
   * page - Activity Plan
   */
  {
    helpTipType: 'activity.activityPlan',
    content: <Trans i18nKey="grant_trial.help_tips.activity_activity_plan" />,
  },

  /**
   * page - Evaluation
   */
  {
    helpTipType: 'activity.evaluationPlan',
    content: <Trans i18nKey="grant_trial.help_tips.activity_evaluation_plan" />,
  },

  /**
   * page - Documentation
   */
  {
    helpTipType: 'activity.documentation',
    content: <Trans i18nKey="grant_trial.help_tips.activity_documentation" />,
  },

  /*
   * page - Report
   */ {
    helpTipType: 'activity.report',
    content: <Trans i18nKey="grant_trial.help_tips.activity_report" />,
  },
];

// for getting projects texts only (for placeholders)
export const getGrantTrialDefinedTexts = (
  projectId,
  defaultText,
  textId,
  additionalTextValue
) => {
  const isTrialProject = grantTrialProgramProjectIds.includes(projectId);

  let textValue = null;
  if (isTrialProject) {
    const projectTextsData = grantTrialDefinedTexts(additionalTextValue);
    const projectTextItem = projectTextsData.find(
      (item) => item.id === Number(textId)
    );
    textValue = get(projectTextItem, 'text', null);
  }

  if (!textValue) {
    textValue = defaultText;
  }

  return textValue;
};
